import { render, staticRenderFns } from "./extract-results.vue?vue&type=template&id=9766d542&scoped=true"
import script from "./extract-results.vue?vue&type=script&lang=js"
export * from "./extract-results.vue?vue&type=script&lang=js"
import style0 from "./extract-results.vue?vue&type=style&index=0&id=9766d542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9766d542",
  null
  
)

export default component.exports